import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const BeautySalonFAQ = () => {
  const [openItems, setOpenItems] = useState(new Set([0])); // First item open by default

  const faqData = [
    {
      id: 0,
      question: "How do I book an appointment for makeup services?",
      answer: "You can book an appointment by calling our salon directly, using our online booking system on our website, or visiting us in person. We recommend booking at least 48 hours in advance for special occasion makeup. For bridal makeup, please book 2-3 weeks ahead to ensure availability."
    },
    {
      id: 1,
      question: "What makeup services do you offer?"
    },
    {
      id: 2,
      question: "How long does a full makeup session take?"
    },
    {
      id: 3,
      question: "Do you provide makeup for special events and weddings?"
    },
    {
      id: 4,
      question: "What are your makeup service pricing options?"
    },
    {
      id: 5,
      question: "Can I get a makeup consultation before my appointment?"
    }
  ];

  const toggleItem = (id) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(id)) {
      newOpenItems.delete(id);
    } else {
      newOpenItems.add(id);
    }
    setOpenItems(newOpenItems);
  };

  return (
    <section className="w-full bg-pink-50 py-16 px-4 sm:px-8 md:px-16 lg:px-20">
      <div className="max-w-4xl mx-auto">
        {/* Header Section */}
        <div className="flex items-start gap-3 mb-12">
          <div className="w-[4px] min-h-[70px] bg-gradient-to-b from-pink-500 to-purple-500 rounded-sm" />
          <div>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900">
              Frequently asked questions
            </h2>
          </div>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqData.map((item) => {
            const isOpen = openItems.has(item.id);
            
            return (
              <div
                key={item.id}
                className="bg-white rounded-2xl shadow-lg border-2 border-transparent  p-[2px] overflow-hidden transition-all duration-500 hover:shadow-lg hover:scale-[1.01] group"
              >
                <div className="bg-white rounded-2xl h-full relative overflow-hidden backdrop-blur-sm border border-gray-100/50">
                <button
                  onClick={() => toggleItem(item.id)}
                  className="w-full px-8 py-6 text-left flex items-center justify-between group/button focus:outline-none focus:ring-4 focus:ring-blue-50/20 focus:ring-inset relative z-10"
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${item.id}`}
                >
                  {/* Gradient background on hover */}
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
                  
                  <span className="text-lg font-medium text-gray-900 pr-8 group-hover/button:bg-gradient-to-r group-hover/button:text-blue-600 group-hover/button:bg-clip-text transition-all duration-300 relative z-10">
                    {item.question}
                  </span>
                  <div className="flex-shrink-0 relative z-10">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-all duration-500  ${
                      isOpen 
                        ? 'bg-white text-blue-600 rotate-180 border-2 border-blue-100' 
                        : 'bg-white text-blue-600 group-hover/button:scale-110 border-2 border-blue-100'
                    }`}>
                      {isOpen ? (
                        <Minus className="w-5 h-5 font-bold" />
                      ) : (
                        <Plus className="w-5 h-5 font-bold" />
                      )}
                    </div>
                  </div>
                </button>
                
                <div
                  id={`faq-answer-${item.id}`}
                  className={`transition-all duration-500 ease-in-out overflow-hidden ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                  role="region"
                  aria-labelledby={`faq-question-${item.id}`}
                >
                  <div className="px-8 pb-7 relative">
                    <div className="pt-2 text-gray-700 leading-relaxed text-base relative">
                      {/* Decorative line */}
                      <div className="absolute -top-3 left-0 w-16 h-0.5 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full"></div>
                      {item.answer || "We offer a comprehensive range of makeup services including everyday natural looks, glamorous evening makeup, bridal packages, special event styling, makeup lessons, and color consultations. Our experienced artists use premium products to enhance your natural beauty for any occasion."}
                    </div>
                  </div>
                </div>
                </div>
              </div>
            );
          })}
        </div>


      </div>
    </section>
  );
};

export default BeautySalonFAQ;